const URL = {
    DEV: 'http://localhost:8000',
    TEST: 'https://backoffice.ibdi-ci.com',
    PROD: ''
}

export const BASE_URL = URL.TEST
export const API_PREFIX = '/api'
export const API_VERSION = '/v1'


// WEBPACK FOOTER //
// ./src/config/urls.js